import { makeStyles } from '@mui/styles';
import { LYNKED_WHITE, LYNKED_DEEP_GREEN, LYNKED_DEEP_GREEN_HOVER } from '../../consts/colors';

const useStyles = makeStyles(() => ({
  TextInput: {
    margin: '0 1rem',
    textAlign: 'left',
  },
  languageDropdown: {
    position: 'fixed',
    right: '90px',
    color: 'white',
    backgroundColor: LYNKED_DEEP_GREEN,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '0px 0px 10px 10px',
    padding: '20px 0 10px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  listItemDropdown: {
    '&': {
      top: '50px !important',
      right: '90px',
      backgroundColor: LYNKED_DEEP_GREEN,
      width: '150px',
      boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 13px 14px 2px rgba(0,0,0,0.12)',
    },
  },
  logoWrapper: {},
  lynkedLogo: {
    width: '100%',
    textAlign: 'center',
    minHeight: '10vh',
  },
  loginInputText: {
    margin: '1rem 0px',
    width: '450px',
    '@media (max-width: 600px)': {
      width: '350px',
    },
  },
  loginInputPasswordText: {
    margin: '1rem 0px',
    width: '450px',
    '@media (max-width: 600px)': {
      width: '350px',
    },
  },
  textMessages: {
    margin: '20px 0px',
    fontFamily: 'Bayon',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '30px',
  },
  footerText: {
    position: 'fixed',
    bottom: '10px',
    textAlign: 'center',
    width: '450px',
    '@media (max-width: 600px)': {
      width: '350px',
    },
  },
  login_form: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginInput: {
    textAlign: 'center',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    order: 3,
    padding: '0px',
    width: '100%',
    height: '100vh',
  },
  loginAd: {
    width: '100%',
    order: 2,
    padding: '0px',
    height: '45%',
    '@media (min-width: 600px)': {
      height: '45vh',
    },
    '@media (min-width: 1280px)': {
      width: '50%',
      height: '100vh',
    },
  },
  loginRoot: {
    backgroundColor: LYNKED_WHITE,
    height: '100%',
    width: '100%',
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '@media (min-width: 960px)': {
      justifyContent: 'space-between',
      flexDirection: 'column',
      display: 'flex',
      height: '100%',
    },
    '@media (min-width: 1280px)': {
      flexDirection: 'row',
      display: 'flex',
      height: '100%',
    },
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
  },
  terms_and_conds_link: { color: LYNKED_WHITE },
}));

const buttonStyle = {
  width: 'max-content',
  backgroundColor: LYNKED_DEEP_GREEN,
  height: '47px',
  borderRadius: '4px',
  opacity: '1',
  color: 'white',
  margin: '20px 0px',
  '&:hover': { backgroundColor: LYNKED_DEEP_GREEN_HOVER },
};

const buttonCancelStyle = {
  width: 'max-content',
  backgroundColor: 'var(--Base-White, #FFF)',
  height: '47px',
  borderRadius: '4px',
  opacity: '1',
  color: 'white',
  border: '1px solid var(--Gray-300, #D0D5DD)',
  margin: '20px 0px',
  '&:hover': { backgroundColor: '#FFF' },
};

export { useStyles, buttonStyle, buttonCancelStyle };
